// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__1JwSm","actions":"GroupTable_actions__37s6-","deleteModalFooter":"GroupTable_deleteModalFooter__3RT8W"};